import { h } from 'preact'
import ButtonControl from '../button-control'

interface ActionButtonsProps {
    onSave: () => void,
    onCancel: () => void,
}
export const ActionButtons = ({ onSave, onCancel }: ActionButtonsProps) => (
  <div className='panel-buttons-container'>
    <ButtonControl newStyle size='medium' variant='save' title='Save changes' onClick={() => onSave()} />
    <ButtonControl newStyle size='medium' title='Cancel' onClick={() => onCancel()} />
  </div>
)
